export default __webpack_public_path__ + "static/media/The-Kitchen-Sisters.50183c26.png";